// Refactor 02/2026 — extrahiert aus AppointmentsPage.js. Header-Zelle für
// eine Trainer-Spalte in der Tages-Ansicht (mit Drag&Drop-Reorder pro Studio
// + Ferien-Banner).
import React from 'react';

const isOnVacation = (trainerId, currentDate, trainerVacations) => {
  if (!trainerVacations || !trainerVacations.length) return null;
  const today = currentDate.toDateString();
  return trainerVacations.find((v) => {
    if (v.trainer_id !== trainerId) return false;
    const start = new Date(v.start_date).toDateString();
    const end = new Date(v.end_date).toDateString();
    const cur = new Date(currentDate);
    const s = new Date(v.start_date);
    const e = new Date(v.end_date);
    return cur >= new Date(s.toDateString()) && cur <= new Date(e.toDateString())
      || today === start || today === end;
  }) || null;
};

export const TrainerColumnHeader = ({
  trainerData,
  studioFilter,
  draggingTrainerId,
  dragOverTrainerId,
  setDraggingTrainerId,
  setDragOverTrainerId,
  onColumnDrop,
  isTrainerOnVacation,
}) => {
  const canDrag = studioFilter && studioFilter !== 'all';
  const trainerId = trainerData.trainer.id;
  const vacation = isTrainerOnVacation
    ? isTrainerOnVacation(trainerId)
    : null;

  return (
    <th
      draggable={canDrag}
      onDragStart={(e) => {
        if (!canDrag) {
          e.preventDefault();
          return;
        }
        setDraggingTrainerId(trainerId);
        try {
          e.dataTransfer.effectAllowed = 'move';
          e.dataTransfer.setData('text/plain', trainerId);
        } catch {
          /* noop */
        }
      }}
      onDragOver={(e) => {
        if (!draggingTrainerId) return;
        e.preventDefault();
        if (dragOverTrainerId !== trainerId) setDragOverTrainerId(trainerId);
      }}
      onDragLeave={() => {
        if (dragOverTrainerId === trainerId) setDragOverTrainerId(null);
      }}
      onDrop={(e) => {
        e.preventDefault();
        onColumnDrop(trainerId);
      }}
      onDragEnd={() => {
        setDraggingTrainerId(null);
        setDragOverTrainerId(null);
      }}
      data-testid={`trainer-column-header-${trainerId}`}
      className={`p-3 text-center font-semibold text-sm border-l min-w-[200px] select-none ${
        canDrag ? 'cursor-move' : ''
      } ${draggingTrainerId === trainerId ? 'opacity-40' : ''} ${
        dragOverTrainerId === trainerId &&
        draggingTrainerId &&
        draggingTrainerId !== trainerId
          ? 'bg-teal-50 ring-2 ring-teal-400'
          : ''
      }`}
      style={{
        borderTopColor: trainerData.availability?.color || '#3B82F6',
        borderTopWidth: '4px',
      }}
      title={canDrag ? 'Spalte zum Verschieben ziehen' : ''}
    >
      <div className="flex items-center justify-center gap-1">
        {canDrag && (
          <span
            className="text-gray-300 text-xs leading-none"
            aria-hidden
          >
            ⠿
          </span>
        )}
        <span>
          {trainerData.trainer.first_name} {trainerData.trainer.last_name}
        </span>
      </div>
      <div className="text-xs font-normal text-gray-500">
        {trainerData.trainer.role}
      </div>

      {/* Vacation Banner if trainer is on vacation */}
      {vacation && (
        <div className="mt-2 bg-gray-300 text-gray-700 px-2 py-1 rounded text-xs font-medium">
          🏖️ In Ferien (
          {new Date(vacation.start_date).toLocaleDateString('de-DE')} -{' '}
          {new Date(vacation.end_date).toLocaleDateString('de-DE')})
        </div>
      )}
    </th>
  );
};

export default TrainerColumnHeader;
